import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import Web3context from '../contexts/Web3context.js'

const Drawer = () => {
  const web3context = useContext(Web3context)
  let { getWeb3, logoutWeb3, loginWeb3, trimAdd } = web3context;

  return (
    <div className="leftSideSection">
      <div className="logoSections">
        {
          getWeb3 ?
            <div className={"btn-group"} role="group">
              <button id="btnGroupDrop1" type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                My Account
              </button>
              <div className="dropdown-menu">
                <div className="dropdown-item" >{trimAdd(getWeb3.currentProvider.selectedAddress)}</div>
                <div className="dropdown-item" onClick={logoutWeb3}>Logout</div>
              </div>
            </div>
            :
            <button onClick={loginWeb3}>CONNECT WALLET</button>
        }
      </div>
      <ul>
        <li><NavLink exact to="/">Home</NavLink></li>
        <li><NavLink exact to="/ingredients">Ingredients</NavLink></li>
        <li><NavLink exact to="/recipes">Recipes</NavLink></li>
        <li><NavLink exact to="/stake">Stake</NavLink></li>
        <li><NavLink exact to="/claim">Claim</NavLink></li>
      </ul>
      <div className="leftSideFooter">
        <ul>
          <li>
            <a href="/">
              <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14 0C6.26795 0 0 6.26795 0 14C0 21.732 6.26795 28 14 28C21.732 28 28 21.732 28 14C28 6.26795 21.732 0 14 0Z"
                  fill="#40B3E0" />
                <path
                  d="M20.8122 8.05332L18.3116 20.6609C18.3116 20.6609 17.9619 21.5352 17.0002 21.1155L11.2298 16.6915L9.1315 15.6774L5.59935 14.4883C5.59935 14.4883 5.05729 14.296 5.00479 13.8763C4.95229 13.4567 5.61685 13.2294 5.61685 13.2294L19.658 7.72126C19.658 7.72126 20.8121 7.2142 20.8121 8.05354"
                  fill="white" />
                <path
                  d="M10.7863 20.5191C10.7863 20.5191 10.6179 20.5033 10.4079 19.8388C10.1982 19.1743 9.1315 15.6772 9.1315 15.6772L17.6122 10.2915C17.6122 10.2915 18.1019 9.99427 18.0844 10.2915C18.0844 10.2915 18.1718 10.344 17.9094 10.5888C17.6472 10.8337 11.2474 16.5865 11.2474 16.5865"
                  fill="#D2E5F1" />
                <path
                  d="M13.4423 18.3876L11.16 20.4686C11.16 20.4686 10.9815 20.604 10.7863 20.5191L11.2234 16.6538"
                  fill="#B5CFE4" />
              </svg>
            </a>
          </li>
          <li>
            <a href="/">
              <svg viewBox="0 0 35 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M34.2983 3.40955C33.0363 3.96915 31.6803 4.34735 30.257 4.5175C31.7099 3.64668 32.8254 2.26771 33.3507 0.624691C31.9696 1.44431 30.4585 2.02178 28.8827 2.33216C27.5991 0.96471 25.7705 0.110107 23.7466 0.110107C19.8606 0.110107 16.71 3.26058 16.71 7.14628C16.71 7.69784 16.7723 8.2348 16.8922 8.74992C11.0444 8.45638 5.85971 5.65518 2.38918 1.39811C1.78363 2.43732 1.43665 3.64615 1.43665 4.93549C1.43665 7.37671 2.67896 9.5303 4.56688 10.7922C3.4495 10.7572 2.35669 10.4554 1.37971 9.91198C1.37931 9.94146 1.37931 9.97093 1.37931 10.0005C1.37931 13.4097 3.80472 16.2536 7.02352 16.9001C5.98736 17.1819 4.90051 17.2231 3.84598 17.0206C4.74131 19.8161 7.33996 21.8503 10.4189 21.9072C8.01075 23.7944 4.9767 24.9193 1.6802 24.9193C1.11217 24.9193 0.552167 24.886 0.00167847 24.821C3.11557 26.8174 6.81412 27.9823 10.7877 27.9823C23.7303 27.9823 30.8076 17.2604 30.8076 7.9623C30.8076 7.65711 30.8009 7.35367 30.7872 7.05196C32.1647 6.05613 33.3537 4.8227 34.2983 3.40955Z"
                  fill="#55ACEE" />
              </svg>
            </a>
          </li>
          <li>
            <a href="/">
              <svg viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.9012 0H3.16886C1.5891 0 0.302917 1.28609 0.302917 2.8798V21.7801C0.302917 23.3738 1.58901 24.6599 3.16876 24.6599H19.0215L18.2805 22.0737L20.07 23.7372L21.7614 25.3029L24.7671 27.959V2.8798C24.7671 1.28609 23.481 0 21.9012 0ZM16.5052 18.2573C16.5052 18.2573 16.0019 17.6562 15.5825 17.1249C17.4139 16.6076 18.1128 15.4614 18.1128 15.4614C17.5396 15.8388 16.9945 16.1045 16.5052 16.2861C15.8062 16.5797 15.1352 16.7753 14.4782 16.8872C13.1361 17.1389 11.9059 17.069 10.8575 16.8733C10.0606 16.7194 9.37559 16.4958 8.8025 16.2722C8.48092 16.1463 8.13145 15.9926 7.78188 15.7969C7.74002 15.7689 7.69807 15.7549 7.65612 15.7269C7.62821 15.713 7.61417 15.699 7.60021 15.6851C7.3486 15.5453 7.20879 15.4474 7.20879 15.4474C7.20879 15.4474 7.87983 16.5658 9.6552 17.0969C9.23587 17.6282 8.71859 18.2572 8.71859 18.2572C5.62903 18.1594 4.45485 16.1324 4.45485 16.1324C4.45485 11.631 6.46789 7.98229 6.46789 7.98229C8.48092 6.47249 10.3961 6.51444 10.3961 6.51444L10.5359 6.68225C8.01964 7.40901 6.85931 8.51353 6.85931 8.51353C6.85931 8.51353 7.16684 8.34582 7.68402 8.10815C9.17987 7.45106 10.3682 7.26939 10.8575 7.22744C10.9413 7.21339 11.0112 7.19944 11.0951 7.19944C12.032 7.0774 12.98 7.06803 13.919 7.17154C15.247 7.3253 16.673 7.71672 18.1268 8.51353C18.1268 8.51353 17.0225 7.46511 14.6459 6.73816L14.8416 6.51454C14.8416 6.51454 16.7568 6.47249 18.7698 7.98239C18.7698 7.98239 20.783 11.631 20.783 16.1324C20.783 16.1324 19.5946 18.1594 16.5052 18.2572V18.2573ZM10.0047 11.7288C9.20787 11.7288 8.57888 12.4278 8.57888 13.2805C8.57888 14.1333 9.22183 14.8323 10.0047 14.8323C10.8016 14.8323 11.4306 14.1333 11.4306 13.2805C11.4446 12.4278 10.8016 11.7288 10.0048 11.7288H10.0047ZM15.1073 11.7288C14.3104 11.7288 13.6813 12.4278 13.6813 13.2805C13.6813 14.1333 14.3244 14.8323 15.1073 14.8323C15.9041 14.8323 16.5331 14.1333 16.5331 13.2805C16.5331 12.4278 15.9041 11.7288 15.1073 11.7288Z"
                  fill="#7289DA" />
              </svg>
            </a>
          </li>
        </ul>
        <p>© RELATABLE</p>
      </div>
    </div>
  );
}

export default Drawer;
